import { SomacylEntregablesDTO } from "sigo-entities";
import { indexedDB } from "../../../useIndexedDB";

export async function helperUploadPhotos(
    entregables: SomacylEntregablesDTO,
    _id: string,
    Files: File[]
) {
    const doc = await indexedDB.somacyl_orders.get(_id)
    if (!doc) throw new Error('Documento no encontrado')

    await indexedDB.transaction(
        'rw',
        indexedDB.somacyl_orders,
        indexedDB.images_somacyl_orders,
        async () => {
            doc.entregables = entregables
            await indexedDB.somacyl_orders.put({
                ...doc,
                pendingSync: 1,
                updatedAt: Date.now()
            })
            for (const file of Files) {
                await indexedDB.images_somacyl_orders.put({
                    id: file.name,
                    file: file,
                    pendingSync: 1
                })
            }
        }
    )
}